import { AnyObject, ObjectSchema, object } from 'yup'

const combineSchemas = (schemas: ObjectSchema<AnyObject>[]) => {
  let combinedSchema = object({})

  schemas.forEach((schema) => {
    combinedSchema = combinedSchema.concat(schema)
  })

  return combinedSchema
}

export default combineSchemas
